import { FC } from 'react';

import View from './view';

const PortalSettingsPage: FC = () => {
  return <View />;
};
export default PortalSettingsPage;
